import { $host, handleError, handleResponse } from "./index";

export const promocodeApply = async (promo_code) => {
    try {
        const res = await $host.post(`/api/payments/promocode/apply`, {
            promo_code
        }, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
}
